import React from "react";
import dynamic from "next/dynamic";
import ContactUsForm from "../../organisms/ContactUs/ContactUsForm";
const ContactUsMap = dynamic(
    () => import("../../organisms/ContactUs/ContactUsMap"),
    {
        ssr: false,
    }
);

export default function ContactUs(props) {
    return (
        <div>
            <div id="content-inner">
                <section className="section-header bg-gradient-dark text-dark pb-9 pb-lg-13 mb-4 mb-lg-6 py-lg ">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-8 text-center">
                                <h1 className="display-2 mb-3 text-light pt-lg-3">
                                    Got a question?
                                </h1>
                                <p className="lead text-gray-500">
                                    Leave us a message below and we'll get in
                                    touch with you as soon as we can.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="section section-lg pt-lg-0 pt-6">
                    <div className="container mt-n8 mt-lg-n13 z-2">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                {/* <!-- Card --> */}
                                <div className="card border-light shadow-soft p-lg-2 p-md-4 p-lg-5">
                                    <div className="card-body p-0">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <h2 className="card-header">
                                                        Contact us
                                                    </h2>
                                                    <div className="card-body">
                                                        <div className="row mb-3 no-gutters">
                                                            <div className="">
                                                                <span className="fa-stack fa-sm">
                                                                    <i className="fas fa-stack-2x fa-square text-dark"></i>
                                                                    <i className="fas fa-stack-1x fa-at text-light"></i>
                                                                </span>
                                                            </div>
                                                            <div className="flex-fill ml-2">
                                                                <a
                                                                    target="_blank"
                                                                    rel="noopener"
                                                                    href="mailto:info@inuua.net"
                                                                    className="analytics-contact-us-email font-weight-bold"
                                                                >
                                                                    info@inuua.net
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-3 no-gutters">
                                                            <div className="">
                                                                <span className="fa-stack fa-sm">
                                                                    <i className="fas fa-stack-2x fa-square text-dark"></i>
                                                                    <i className="fas fa-stack-1x fa-phone text-light"></i>
                                                                </span>
                                                            </div>
                                                            <div className="flex-fill ml-2">
                                                                <a
                                                                    target="_blank"
                                                                    rel="noopener"
                                                                    href="tel:+254769411616"
                                                                    className="analytics-contact-us-phone font-weight-bold"
                                                                    content="+254769411616"
                                                                >
                                                                    +254 769 411 616
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="row flex-column no-gutters">
                                                            <div className="">
                                                                <span className="fa-stack fa-sm">
                                                                    <i className="fas fa-stack-2x fa-square text-dark"></i>
                                                                    <i className="fas fa-stack-1x fa-comment-alt text-light"></i>
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <span className="font-weight-bold">
                                                                    Send us a
                                                                    message
                                                                </span>
                                                            </div>
                                                            <ContactUsForm />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=" col-md-6">
                                                <div className="card">
                                                    <h2 className="card-header">
                                                        Visit us
                                                    </h2>
                                                    <div className="card-body">
                                                        <div
                                                            itemProp="address"
                                                            itemType="http://schema.org/PostalAddress"
                                                        >
                                                            <p>
                                                                Vyumba Limited,
                                                                <br />
                                                                <span itemProp="streetAddress">
                                                                    Belgravia
                                                                    Building,
                                                                    <br />
                                                                    14 Riverside
                                                                    Drive,
                                                                    <br />
                                                                    Nairobi
                                                                </span>
                                                            </p>
                                                        </div>

                                                        <ContactUsMap />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="section section-lg pt-5 line-bottom-light">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-12 col-md-4 text-center px-4 mb-5 mb-lg-0">
                                                <div className="icon icon-sm icon-shape icon-shape-primary rounded mb-4">
                                                    <i className="fab fa-whatsapp"></i>
                                                </div>
                                                <h5 className="mb-3">
                                                    WhatsApp us
                                                </h5>
                                                <p>
                                                    Click the number below to
                                                    send us a message on
                                                    WhatsApp
                                                </p>

                                                <a
                                                    target="_blank"
                                                    rel="noopener"
                                                    className="analytics-contact-us-whatsapp text-primary"
                                                    href="https://api.whatsapp.com/send?phone=+254769411616"
                                                    itemProp="telephone"
                                                >
                                                    +254 769 411 616
                                                </a>
                                            </div>
                                            <div className="col-12 col-md-4 text-center px-4 mb-5 mb-lg-0">
                                                <div className="icon icon-sm icon-shape icon-shape-primary rounded mb-4">
                                                    <i className="fas fa-envelope-open-text"></i>
                                                </div>
                                                <h5 className="mb-3">
                                                    Email us
                                                </h5>
                                                <p>
                                                    Email us for general queries
                                                    or feedback, including
                                                    marketing and partnership
                                                    opportunities.
                                                </p>
                                                <a
                                                    target="_blank"
                                                    rel="noopener"
                                                    className="analytics-contact-us-email font-weight-bold text-primary"
                                                    href="mailto:info@inuua.net"
                                                    itemProp="email"
                                                >
                                                    info@inuua.net
                                                </a>
                                            </div>
                                            <div className="col-12 col-md-4 text-center px-4 mb-5 mb-lg-0">
                                                <div className="icon icon-sm icon-shape icon-shape-primary rounded mb-4">
                                                    <i className="fas fa-phone-volume"></i>
                                                </div>
                                                <h5 className="mb-3">
                                                    Call us
                                                </h5>
                                                <p>
                                                    Click the number below to
                                                    call us and speak to a
                                                    member of our team.We are
                                                    always happy to help you.
                                                </p>

                                                <span>
                                                    <a
                                                        target="_blank"
                                                        rel="noopener"
                                                        itemProp="telephone"
                                                        className="analytics-contact-us-phone"
                                                        href="tel:+254769411616"
                                                        content="+254769411616"
                                                    >
                                                        +254 769 411 616
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
